import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment'
import styled, { keyframes } from 'styled-components'

import { 
  editSchedule, 
  removeSchedule, 
  focusSchedule, 
  focusLastSchedule, 
  attachStationsToSchedule, 
  removeScheduleFromDb, 
  saveScheduleToDb, 
  saveSchedulesToDb 
} from '../../../store/rules/ruleSchedulesSlice';
import { getSettings } from '../../../store/rules/settingsSlice';
import { Schedule, EditSchedule } from '../../../store/rules/types';
import { Icon } from '@iconify/react';
import warningIcon from '@iconify/icons-carbon/warning';
import { colour_lookup } from '../../common/Colours';

const StyledTextInput = styled.input`
  font-size: 16px;
  border: 0;
  padding: 5px;
  margin: 10px auto;
  width: 80%;
  display: block;
  text-align: center;
  font-size: 20px;
  color: #333;
  
  &:disabled {
    background: #FFF;
    color: #555;
  }
  
  &:focus {
    border-bottom: 1px solid #ddd;
  }
  
  
`;

const TextInput = ({ disabled=false, value, onChange }: { disabled?: boolean; value: string; onChange?: any }) => {
  return (
    <StyledTextInput disabled={disabled} type="text" onChange={onChange} value={value}/>
  )
}

const StyledTextAreaInput = styled.textarea`
  font-size: 16px;
  border: 0;
  padding: 10px;
  margin: 0px auto;
  width: 80%;
  display: block;import { colour_lookup }
  resize: none;
  color: #444;
  font-size: 15px;
  line-height: 22px;
  font-family: inherit;
  background: #fff;
  color: #555;
  
  &:hover {
    border: 1px solid #ddd;
  }
  
  &:focus {
    border: 1px solid #ddd;
  }
`;

const TextAreaInput = ({ disabled=false, value, onChange }: { disabled?: boolean; value: string; onChange?: any }) => {
  return (
    <StyledTextAreaInput disabled={disabled} rows={6} value={value} onChange={onChange}></StyledTextAreaInput>
  )
}

const StyledHelp = styled.div`
  font-size: 16px;
  width: 80%;
  margin: 0 auto;
  color: #444;
  font-size: 14px;
  line-height: 22px;
  font-family: inherit;
  background: #fff;
  color: #666;
  font-style: italic;
`;


const StyledOption = styled.option`
  background: #FFF;
`;

const StyledSelect = styled.select`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* Add some styling */

  display: block;
  // width: 100%;
  width: 80px;
  height: 35px;
  float: right;
  padding: 0px 10px;
  font-size: 16px;
  line-height: 1.75;
  color: #333;
  background-color: #ffffff;
  background-image: none;
  border: 1px solid #cccccc;
  border-radius: 35px;
  text-align: center;
  margin: 0 auto;

`;

const HourSelector = ({date, onChange}: {date: string; onChange?: any}) => {
  return (
    <StyledSelect
        value={moment(date).format('H')}
        onChange={onChange}
      >
    {Array.from(Array(25).keys()).map((value, index) => {
      return <StyledOption value={value}>{value.toString().padStart(2, '0')}:00</StyledOption>
    })}
    </StyledSelect>
  )
}

const DurationSelector = ({duration, onChange}) => {
  return (
    <StyledSelect
        value={duration/3600}
        onChange={onChange}
      >
    {Array.from(Array(49).keys()).map((value, index) => {
      return <option value={value}>{value.toString()}hr</option>
    })}
    </StyledSelect>
  )
}
  

const RepeatSelector = ({selected, labels, onChange}) => {
  
  const StyledRepeatSelector = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
  `;
  
  const DaySelect = styled.span<{selected: boolean}>`
    display: inline-block;
    width: 30px;
    height: 30px;
    border-radius: 15px;
    background: ${props => props.selected? '#3174ad' : '#FFF'};
    text-align: center;
    color: ${props => props.selected? '#FFF' : '#3174ad'};
    border: 1px solid #3174ad;
    line-height: 30px;
    margin: 0 1px;
    
    &:hover {
      cursor: pointer;
    }
  `;
  
  const onClick = (value) => {
    return () => {
      let new_selected = selected.map(item => item);
      
      if (!selected.includes(value)) {
        new_selected.push(value);
      } else {
        new_selected = selected.filter((item) => {
          if (item !== value) {
            return true;
          }
        })
      }
      
      onChange({ selected: new_selected })
    }
  }
  
  return (
    <StyledRepeatSelector>
      {labels.map((item, index) => {
        return <DaySelect onClick={onClick(index)} selected={selected.includes(index)}>{item}</DaySelect>
      })}
    </StyledRepeatSelector>
  )
}

const Actions = ({schedule, children}: {schedule: EditSchedule; children?: React.ReactNode}) => {
  
  const StyledActions = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
  `;
  
  return (
    <StyledActions>
      {schedule.editable? children: null}
    </StyledActions>
  )
}

const Button = ({text, background, disabled, onClick}: {text: string; background?: string; disabled?: boolean; onClick?: any}) => {
  
  const StyledButton = styled.button<{background?: string; disabled?: boolean}>`
    background: ${props => props.disabled? '#888888' : props.background};
    color: #FFFFFF;
    border: 0;
    height: 35px;
    padding: 0 15px;
    margin: 0 10px;
    font-size: 16px;
    border-radius: 35px;
    cursor: pointer;
  `;
  
  return (
    <StyledButton disabled={disabled} background={background} onClick={onClick}>{text}</StyledButton>
  )
}

const StyledMessage = styled.div`
  font-size: 16px;
  width: 80%;
  margin: 0 auto;
  color: #444;
  font-size: 14px;
  line-height: 22px;
  font-family: inherit;
  background: #fff;
  color: #666;
  text-align: center;
`;

const Message = ({schedule, global}) => {
  return (
    <StyledMessage>
      {global.message}
    </StyledMessage>
  )
}

const StyledEditPanel = styled.div`
  // height: 100%;
  padding-top: 10px;
`;

const Label = styled.div`
  color: #555;
  text-align: center;
  margin: 0 0 10px 0;
`;

const Display = ({ show, children }: { show: boolean, children?: React.ReactNode }) => {
  return (
    <div>
      {show? children: null}
    </div>
  )
}

const StyledColumn = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center
`;

const Column = ({ children }: { children?: React.ReactNode }) => {
  return (
    <StyledColumn>
      {children}
    </StyledColumn>
  )
}

const StyledRow = styled.div`
  width: 90%;
  display: flex;
  flex-direction: row;
  margin: 30px auto 0 auto;
`;

const Separator = styled.div`
  border-bottom: 2px dashed #ddd;
  margin-top: 30px;
`;

const Row = ({ children }: { children?: React.ReactNode }) => {
  return (
    <StyledRow>
      {children}
    </StyledRow>
  )
}

const StyledOverlappingHelp = styled.div`
  width: 90%;
  margin: 0 auto;
  font-size: 16px;
  color: #333;
`;

const OverlappingTitle = styled.div`
  display: flex;
  
  p {
    padding: 8px 0 0 10px;
  }
`;

const OverlappingMessage = styled.div`
  width: 90%;
  margin: 20px auto 0 auto;
  font-size: 14px;
  line-height: 22px;
  color: #555;
  font-style: italic;
`;

const OverlappingHelp = ({ isOverlapping }: { isOverlapping: any; }) => {
  
  return (
    <StyledOverlappingHelp>
      <OverlappingTitle>
        <Icon width='30px' height='30px' color={colour_lookup('red')} icon={warningIcon} /> 
        <p>Overlapping Schedules</p>
      </OverlappingTitle>
      <OverlappingMessage>
        Please edit the highlighted schedules so they do not overlap. Schedules cannot be saved when overlapping.
      </OverlappingMessage>
    </StyledOverlappingHelp>
  )
}

export function EditPanel({schedule, schedules, isOverlapping}: {schedule: EditSchedule, schedules: EditSchedule[], isOverlapping: any;}) {
  
  // Check if any schedules are unsaved
  const save_all_enabled = schedules.filter(schedule => !schedule.saved).length > 0? true : false;
  
  const globalSettings = useSelector(getSettings);
  const dispatch = useDispatch();
  
  return (
    <StyledEditPanel>
    
      <TextInput
        disabled={false}
        value={schedule.title}
        onChange={(text_event) => dispatch(editSchedule({id: schedule.id, title: text_event.target.value}))}
      />
      
      <Display show={schedule.editable}>
        
        <Row>
          <Column>
            <Label>Start</Label>
            <HourSelector 
              date={schedule.dtstart} 
              onChange={(select_event) => dispatch(editSchedule({ id: schedule.id, dtstart: moment(schedule.dtstart).hours(select_event.target.value).format('YYYY-MM-DD HH:mm:ss')})) }
            />
          </Column>
          
          <Column>
            <Label>Duration</Label>
            <DurationSelector 
              duration={schedule.duration} 
              onChange={(select_event) => dispatch(editSchedule({id: schedule.id, duration: select_event.target.value*3600}))}
            />
          </Column>
        </Row>
        
        <Row>
          <RepeatSelector 
            selected={schedule.byweekday} 
            labels={['M', 'T', 'W', 'T', 'F', 'S', 'S']} 
            onChange={(select_event) => dispatch(editSchedule({id: schedule.id, byweekday: select_event.selected}))}
          />
        </Row>
        
        <Row>
          <Actions schedule={schedule}>
            <Button background='#CC6666' disabled={false} onClick={() => {dispatch(removeScheduleFromDb(schedule)); dispatch(focusLastSchedule());}} text="Remove"/>
            <Button background='#3174ad' disabled={schedule.saved || isOverlapping.state} onClick={() => {dispatch(saveScheduleToDb(schedule))}} text="Save"/>
          </Actions>
        </Row>
        
      </Display>
      
      {globalSettings.message.length > 0? 
        <Row>
          <Message
            schedule={schedule}
            global={globalSettings}
          />
        </Row>
      : null }
      
      <Separator/>
      
      <Row>
        <Actions schedule={schedule}>
          <Button background='#3174ad' disabled={!save_all_enabled || isOverlapping.state} onClick={() => {dispatch(saveSchedulesToDb(schedules))}} text="Save All"/>
        </Actions>
      </Row>
      
      {isOverlapping.state && <Row>
        <OverlappingHelp isOverlapping={isOverlapping}/>
      </Row>}
      
      {!isOverlapping.state && <Row>
        <StyledHelp>
          Settings will not be implemented until Save is pressed.
        </StyledHelp>
      </Row>}
      
      {!isOverlapping.state && <Row>
        <StyledHelp>
          In Power Saving mode buffered data is uploaded during the last 10 minutes of each hour.
        </StyledHelp>
      </Row>}
      
    </StyledEditPanel>
  );
}